import EditAssetInfo from './EditAssetInfo.vue';

export default EditAssetInfo;
